<template>
    <div>
        <div v-for="(item, index) in list" :key="index + 'listIndex'">
            <div class="ranking-list-item" :class="{ me: isMe }">
                <div class="ranking-num" v-if="isMe">
                    <p>我</p>
                    <p class="color-red">{{ rank(item) }}</p>
                </div>
                <div v-else class="ranking-num">
                    <p v-if="rank(item) > 3">{{ rank(item) }}</p>
                    <div v-else>
                        <van-image class="img" round :src="`https://staticwecom.beautyfarm.com.cn/wecom-workbench/2025-02-18/top${rank(item)}.png`" alt="" />
                    </div>
                    <!-- <img v-else :src="`https://staticwecom.beautyfarm.com.cn/wecom-workbench/2025-02-18/top${rank(item)}.png`" alt=""> -->
                </div>
                <div class="ranking-name">
                    <!--                    <van-image v-if="currentJobTab === '2'" class="img" round :src="item?.avatar" error-icon="" />-->
                    <div>
                        <div>{{ item?.employeeName }}</div>
                        <div class="ellipsis">
                            <div v-if="!isMe">{{ item?.ccKsEmpName }}</div>
                            <div class="sectionName">{{ item?.sectionName }}</div>
                        </div>
                    </div>
                </div>
                <div class="ranking-order">{{ timeJune(item) }}</div>
                <div class="ranking-bonus">{{ saleJune(item) }}</div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'RankingItem',
        props: {
            list: {
                type: Array,
                default: () => []
            },
            isMe: {
                type: Boolean,
                default: false
            },
            index: {
                type: Number,
                default: 0
            },
            currentJobTab: {
                type: String,
                default: '1'
            },
            currentGroupTab: {
                type: String,
                default: '1'
            }
        },
        computed: {
            rank() {
                return function (item) {
                    return item?.rnk
                }
            },
            timeJune() {
                return function (item) {
                    if (this.currentJobTab == 1) {
                        return item?.saleAmtAll ? item?.saleAmtAll + 'w' : 0
                    }
                    if (this.currentJobTab == 2) {
                        return item?.menNum
                    }
                }
            },
            saleJune() {
                return function (item) {
                    if (this.currentJobTab == 1) {
                        return item?.reward || 0
                    }
                    if (this.currentJobTab == 2) {
                        return item?.reward ? item?.reward + 'w' : 0
                    }
                }
            }
        },
        data() {
            return {

            }
        },
        methods: {
        }
    }
</script>

<style lang='less' scoped>
    .ranking-list-item {
        display: flex;
        align-items: center;
        justify-content: space-between;
        // margin: 10px 0;
        padding: 30px 40px;
        border-bottom: 2px solid #eeeeee;

        &.me {
            padding: 20px;
            margin-top: 30px;
            background: #F9F5F0;
            border-radius: 12px;
            border: none;

            .ranking-num {
                width: 70px;
                text-align: center;
                margin-right: 40px;

                div {
                    width: 100%;
                }
            }
        }

        &.meTwo {
            padding: 20px;
            margin-top: 30px;
            background: #FFF5E5;
            border-radius: 12px;
            border: none;

            .ranking-num {
                width: 70px;
                text-align: center;
                margin-right: 40px;

                div {
                    width: 100%;
                }
            }
        }

        &.title {
            padding-bottom: 0;
            border: none;
            color: #999999;
        }

        // &:nth-last-child(1) {
        //     border: none;
        // }

        .ranking-num {
            width: 70px;
            text-align: center;
            //display: flex;
            //align-items: center;
            //justify-content: center;
            margin-right: 40px;

            .color-red {
                color: #AB080B;
            }

            .img {
                width: 50px;
                height: 60px;
            }

            p {
                margin: 0;
                text-align: center;
            }
        }

        .ranking-name {
            display: flex;
            align-items: center;
            flex: 2.5;


            .ellipsis {
                width: 220px;

                .sectionName {

                    white-space: nowrap;
                    /* 禁止换行 */
                    overflow: hidden;
                    /* 隐藏超出内容 */
                    text-overflow: ellipsis;
                    /* 显示省略号 */
                }
            }

            >.img {
                width: 60px;
                height: 60px;
                min-width: 60px;
                margin-right: 10px;
            }

        }

        .ranking-order {
            flex: 1.2;
            text-align: center;
        }

        .ranking-bonus {
            flex: 1.8;
            text-align: center;
        }


        .flagImg {
            width: 65px;
            height: 54px;
        }
    }
</style>
